import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'owlCarousel',
  setup(__props) {

const SlidesOnly = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/SlidesOnly.vue"))
const WithControls = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/WithControls.vue"))
const AutoPlay = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/AutoPlay.vue"))
const MouseWheel = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/MouseWheel.vue"))
const WithIndicators = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/WithIndicators.vue"))
const WithCaptions = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/WithCaptions.vue"))
const CrossFade = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/CrossFade.vue"))
const IndividualCarousel = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/IndividualCarousel.vue"))
const DisableTouch = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/DisableTouch.vue"))
const DarkVariant = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/DarkVariant.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SlidesOnly)),
      _createVNode(_unref(WithControls)),
      _createVNode(_unref(AutoPlay)),
      _createVNode(_unref(MouseWheel)),
      _createVNode(_unref(WithIndicators)),
      _createVNode(_unref(WithCaptions)),
      _createVNode(_unref(CrossFade)),
      _createVNode(_unref(IndividualCarousel)),
      _createVNode(_unref(DisableTouch)),
      _createVNode(_unref(DarkVariant))
    ])
  ]))
}
}

})